export default function SettingsTab({
  requestTimeout,
  setRequestTimeout,
  rateLimit,
  setRateLimit,
  maxRetries,
  setMaxRetries,
  cacheTtl,
  setCacheTtl,
  enableCaching,
  setEnableCaching,
  logRequests,
  setLogRequests,
  enableCompression,
  setEnableCompression,
  sslVerification,
  setSslVerification,
  customHeaders,
  setCustomHeaders
}) {
  return (
    <div className="space-y-8">
      {/* Performance Settings */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Performance Settings
        </h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Request Timeout (ms)
            </label>
            <input
              type="number"
              value={requestTimeout}
              onChange={(e) => setRequestTimeout(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Rate Limit (req/min)
            </label>
            <input
              type="number"
              value={rateLimit}
              onChange={(e) => setRateLimit(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Max Retries
            </label>
            <input
              type="number"
              value={maxRetries}
              onChange={(e) => setMaxRetries(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Cache TTL (seconds)
            </label>
            <input
              type="number"
              value={cacheTtl}
              onChange={(e) => setCacheTtl(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            />
          </div>
        </div>
      </div>

      {/* Data Handling */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Data Handling
        </h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Enable data caching</span>
            <input
              type="checkbox"
              checked={enableCaching}
              onChange={(e) => setEnableCaching(e.target.checked)}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Log API requests</span>
            <input
              type="checkbox"
              checked={logRequests}
              onChange={(e) => setLogRequests(e.target.checked)}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Enable compression</span>
            <input
              type="checkbox"
              checked={enableCompression}
              onChange={(e) => setEnableCompression(e.target.checked)}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">
              SSL certificate verification
            </span>
            <input
              type="checkbox"
              checked={sslVerification}
              onChange={(e) => setSslVerification(e.target.checked)}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
        </div>
      </div>

      {/* Custom Headers */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Custom Headers
        </h3>
        <textarea
          value={customHeaders}
          onChange={(e) => setCustomHeaders(e.target.value)}
          placeholder="X-Custom-Header: value&#10;X-API-Version: 2.0"
          rows={5}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm font-mono resize-none"
        />
        <p className="text-xs text-gray-500 mt-2">
          One header per line in format: Name: Value
        </p>
      </div>
    </div>
  );
}
